"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ucfirst = void 0;
function ucfirst(s) {
    return s.charAt(0).toUpperCase() + s.substring(1);
}
exports.ucfirst = ucfirst;
//# sourceMappingURL=ucfirst.js.map